import React from 'react';
import { Calculator, Clock, Wrench } from 'lucide-react';

const tools = [
  {
    title: 'Instant HVAC Estimate',
    description: 'Get real pricing for AC replacement and installation in minutes.',
    href: '/instant-hvac-estimate-new-orleans',
    icon: Calculator,
    color: 'text-[#F97316]',
    bg: 'bg-orange-50',
  },
  {
    title: 'AC Age Checker',
    description: 'Find out how old your AC unit is using the serial number.',
    href: '/check-ac-age',
    icon: Clock,
    color: 'text-[#0EA5E9]',
    bg: 'bg-sky-50',
  },
  {
    title: 'Replacement Cost Guide',
    description: 'Should you repair or replace? See the cost breakdown.',
    href: '/repair-vs-replace-ac',
    icon: Wrench,
    color: 'text-[#0F172A]',
    bg: 'bg-slate-100',
  },
];

const HomeownerTools = () => {
  return (
    <section className="py-16 bg-white" data-testid="homeowner-tools-section">
      <div className="max-w-6xl mx-auto px-6">
        <h2
          className="text-3xl md:text-4xl font-bold text-center text-[#0F172A] mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Tools for Louisiana Homeowners
        </h2>
        <p className="text-center text-slate-500 mb-12 max-w-xl mx-auto">
          Free resources to help you make smart decisions about your home's HVAC system.
        </p>

        <div className="grid md:grid-cols-3 gap-6">
          {tools.map((tool, i) => (
            <a
              key={i}
              href={tool.href}
              data-testid={`homeowner-tool-${i}`}
              className="group block p-6 rounded-2xl border border-slate-200 hover:border-[#0EA5E9] hover:shadow-lg transition-all duration-300"
            >
              <div className={`w-12 h-12 ${tool.bg} rounded-xl flex items-center justify-center mb-4`}>
                <tool.icon className={`w-6 h-6 ${tool.color}`} />
              </div>
              <h3 className="text-lg font-bold text-[#0F172A] mb-2 group-hover:text-[#0EA5E9] transition-colors">
                {tool.title}
              </h3>
              <p className="text-slate-500 text-sm">{tool.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeownerTools;
